import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import Button from 'shared/ui/Button/Button/Button';
import OpenURL from 'shared/ui/icons/General/OpenURL';
import IHttpIncident from 'features/http/model/HttpIncident/IHttpIncident';
import {buildFileUrl} from 'features/http/lib/fileUrl';
import {isTranslate} from 'shared/lib/lang';

import HttpIncidentModalRow from '../HttpIncidentModalRow/HttpIncidentModalRow';
import HttpIncidentScreenshot from '../HttpIncidentScreenshot/HttpIncidentScreenshot';

import styles from './HttpIncident.module.scss';

interface IHttpIncidentProps {
    item: IHttpIncident,
}

const HttpIncident: React.FC<IHttpIncidentProps> = ({item}) => {
    const contentUrl = buildFileUrl(item.content_file);

    return (
        <ModalBodyWrapper>
            {contentUrl && (
                <div className={styles.actions}>
                    <Button
                        variant="transparent"
                        className={styles.actionButton}
                        onClick={() => window.open(contentUrl, '_blank', 'noopener,noreferrer')}
                    >
                        {t`Просмотр тела ответа`}
                        <OpenURL />
                    </Button>
                </div>
            )}
            <div className={styles.containerGeo}>
                <div className={styles.title}>
                    Проблемы локаций: {item.fail_locations_count} из {item.total_locations_count}
                </div>
                <div className={styles.geoGrid}>
                    <div className={cn(
                        styles.geoHeader,
                        isTranslate() ? styles.enHeader : styles.ruHeader,
                    )}>
                        <div className={styles.headerCell}>{t`Статус`}</div>
                        <div className={styles.headerCell}>{t`Страна/Локация`}</div>
                        <div className={styles.headerCell}>{t`Результат`}</div>
                        <div className={styles.headerCell} />
                    </div>
                    {item.locations.map((loc) => (
                        <HttpIncidentModalRow
                            key={loc.id}
                            item={loc}
                        />
                    ))}
                </div>
            </div>
            <HttpIncidentScreenshot file={item.screenshot_file} />
        </ModalBodyWrapper>
    );
};

export default HttpIncident;